import * as React from 'react'

function IconConcaveCylinderBlocked({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={143}
      viewBox="0 0 104 143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter0_concave)">
            <path
              d="M99.812 130.698c-16.904 16.628-78.72 16.628-95.624 0-10.623-10.449 2.315-34.78 2.315-59.116S-6.435 22.92 4.188 12.472c16.905-16.63 78.72-16.63 95.624 0 10.623 10.448-2.315 34.779-2.315 59.115s12.938 48.657 2.315 59.111z"
              fill="#A2A2A2"
            />
            <path
              d="M52.002 133.714c-18.687 0-35.936-4.156-41.945-10.111-2.705-2.678-.56-13.248 1.332-22.575 1.806-8.906 3.854-18.998 3.854-29.444 0-10.445-2.048-20.537-3.854-29.443-1.892-9.327-4.037-19.897-1.332-22.575C16.066 13.61 33.315 9.455 52.002 9.455s35.937 4.156 41.941 10.11c2.705 2.684.56 13.25-1.331 22.576-1.807 8.906-3.855 18.998-3.855 29.443 0 10.446 2.048 20.538 3.855 29.444 1.89 9.327 4.036 19.897 1.331 22.575-6.004 5.955-23.254 10.111-41.94 10.111z"
              fill="#A2A2A2"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M39.169 58.078l25.662 26.49M64.831 58.078L39.17 84.568"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_concave"
              x={0}
              y={0}
              width={104}
              height={143.169}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M98.893 129.184c-16.58 16.309-77.206 16.309-93.786 0-10.419-10.248 2.271-34.11 2.271-57.979 0-23.867-12.69-47.726-2.27-57.974 16.579-16.308 77.205-16.308 93.785 0 10.419 10.248-2.271 34.111-2.271 57.98 0 23.867 12.69 47.721 2.27 57.973z"
            fill="#fff"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M52.002 132.143c-18.328 0-35.246-4.077-41.138-9.917-2.654-2.627-.55-12.994 1.305-22.141 1.772-8.734 3.78-18.632 3.78-28.877 0-10.245-2.008-20.143-3.78-28.877-1.854-9.148-3.959-19.515-1.305-22.142 5.892-5.84 22.81-9.916 41.138-9.916s35.246 4.076 41.134 9.916c2.654 2.632.55 12.994-1.305 22.142-1.772 8.734-3.78 18.632-3.78 28.877 0 10.245 2.008 20.143 3.78 28.877 1.854 9.147 3.959 19.514 1.305 22.141-5.888 5.84-22.806 9.917-41.134 9.917z"
            fill="#A2A2A2"
            stroke="#fff"
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M39.416 57.961l25.169 25.98M64.585 57.961l-25.17 25.98"
            stroke="#fff"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconConcaveCylinderBlocked
